import * as React from "react"
import { Center, Stack, Text, useColorModeValue } from "@chakra-ui/react"

import { LinkButton } from "./LinkButton"

export function Intro() {
  const color = useColorModeValue("gray.700", "gray.300")
  return (
    <Center role="main" aria-label="Introduction section">
      <Stack spacing={10} textAlign="center" alignItems="center">
        <Text
          as="h1"
          fontSize={{ base: "4xl", md: "5xl" }}
          fontWeight={900}
          px={{ base: 2, md: 48 }}
          lineHeight={{ base: "shorter", md: "short" }}
          id="intro-heading"
        >
          Welkom bij{" "}
          <Text as="span" color="yellow.500">
            Kunstbende!
          </Text>
        </Text>
        <Text
          as="h2"
          color={color}
          fontSize={{ base: "lg", md: "2xl" }}
          px={{ base: 2, md: 32 }}
          pb={2}
          lineHeight="short"
          aria-labelledby="intro-heading"
        >
          Ben je tussen de 13 en 19 jaar en doe je iets met dans, DJ, kunst, fashion, film, muziek, schrijven
          of theater? Bij Kunstbende ontmoet je andere makers, volg je workshops en krijg je feedback op je
          werk. En als je het wilt laten zien, doe je mee aan de voorronde in jouw regio.
        </Text>

        <LinkButton
          href="/inschrijven"
          fontSize={{ base: 16, md: 22 }}
          px={8}
          py={{ base: 6, md: 8 }}
          colorScheme="yellow"
          aria-label="DOE MEE"
        >
          DOE MEE
        </LinkButton>
      </Stack>
    </Center>
  )
}
